import { rem } from "polished";
import React from "react";
import styled from "styled-components";
import {
  changeTexture,
  getSelectedTexture,
  getSelectedTile,
} from "../../../../../../lib/redux/slices/dimensions-slice";
import { useDispatch, useSelector } from "react-redux";
import Button, { ButtonWrapper } from "../../../../../Button";
import Modal from "../../../../../Modal";
import ListItem from "../../../ListItem";
import { useGetBuilderDataQuery } from "../../../../../../lib/redux/api/builder-api";
import ItemDetailModal from "../../../ItemDetailModal";
import { useSearchParams } from "react-router-dom";
import { useUpdateCart } from "../../../../../../hooks/use-update-cart";

const Texture = () => {
  const [open, onSetModal] = React.useState(false);
  const [openDetailModal, onSetDetailModal] = React.useState(false);

  const dispatch = useDispatch();
  const [params] = useSearchParams();

  const category = params.get("cat");
  const catId = params.get("id");
  const { data: builderData = [] } = useGetBuilderDataQuery({
    category,
    catId,
  });
  const textureData = builderData ? builderData.texture : {};
  const selectedTile = useSelector(getSelectedTile);
  const texture = useSelector(getSelectedTexture);
  const { updateCart } = useUpdateCart();


  const [selectedItem, setSelectedItem] = React.useState(texture);

  const changeTextureImage = (selectedTexture) => {
    setSelectedItem(selectedTexture);
    dispatch(changeTexture(selectedTexture));
    updateCart((storeData) => ({
      ...storeData,
      dimensions: {
        ...storeData.dimensions,
        texture: selectedTexture,
      },
    }));
  };

  return (
    <Layout className="builder-element">
      <div className="element">
        <h5>{textureData.label}</h5>
        <div
          className="pattern"
          onClick={() => onSetDetailModal(!openDetailModal)}
        >
          <img src={texture.image} alt="pattern " width={64} height={64} />
        </div>
      </div>

      <ButtonWrapper>
        <Button onClick={() => onSetModal(!open)}>VÄLJ</Button>
      </ButtonWrapper>

      <Modal
        wrapperId="modal"
        isOpen={open}
        overlayClick
        handleClose={() => onSetModal(false)}
        styles={{
          maxWidth: "90%",
          maxHeight: "90%",
          height: "100%",
          width: "100%",
          borderRadius: 0,
        }}
        parentStyles={{
          zIndex: 9999,
        }}
        title={textureData.label || ""}
      >
        {texture && (
          <ListItem
            data={textureData.options}
            onHandleSet={changeTextureImage}
            onModalClose={() => onSetModal(false)}
            setSelectedItem={setSelectedItem}
            onSetDetailModal={onSetDetailModal}
          />
        )}
      </Modal>
      <ItemDetailModal
        title={selectedTile.label}
        selectedItem={selectedItem}
        openDetailModal={openDetailModal}
        onSetDetailModal={onSetDetailModal}
      />
    </Layout>
  );
};
export default Texture;

const Layout = styled.div`
  .element {
    h5,
    .pattern {
      font-size: 14px;
      margin-bottom: ${rem(15)};
      font-weight: bold;
    }
  }
`;
